import type { ReactNode } from 'react';
import { useEntitlement } from '@/hooks/useEntitlement';
import type { EntitlementFeatureKey } from '@/types/package';
import { LockedFeatureCard } from './LockedFeatureCard';

interface FeatureGateProps {
  feature: EntitlementFeatureKey;
  /**
   * Rendered when the feature is locked. Default: <LockedFeatureCard/>. Pass `null` to render nothing.
   */
  fallback?: ReactNode;
  /** Use the compact card as the default fallback */
  compact?: boolean;
  children: ReactNode;
}

/**
 * Renders `children` while the feature is allowed, the locked teaser otherwise.
 * In gating mode off/shadow (default) it always renders `children`.
 */
export const FeatureGate = ({ feature, fallback, compact = false, children }: FeatureGateProps) => {
  const { allowed, upsellPlanSlug } = useEntitlement(feature);
  if (allowed) return <>{children}</>;
  if (fallback !== undefined) return <>{fallback}</>;
  return <LockedFeatureCard feature={feature} upsellPlanSlug={upsellPlanSlug} compact={compact} />;
};

export default FeatureGate;
